{
  "slug": "can-anxiety-lower-iq-scores",
  "title": "L’anxiété peut-elle abaisser les scores des tests de QI?",
  "description": "L’anxiété peut consommer l’attention ou la mémoire de travail, mais les effets varient.",
  "category": "Questions de QI répondues",
  "sections": [
    {
      "heading": "Réponse courte",
      "paragraphs": [
        "L’anxiété peut consommer l’attention ou la mémoire de travail, mais les effets varient."
      ]
    },
    {
      "heading": "Ce qui l'affecte",
      "paragraphs": [
        "La qualité du test, l’âge, la santé, la langue, l’éducation, la motivation, l’environnement et le but sont tous importants.",
        "Un effet moyen d'étude ne peut pas prédire exactement une personne."
      ]
    },
    {
      "heading": "Orientation",
      "paragraphs": [
        "Utilisez un sommeil adéquat, des conditions calmes, des accommodements et un instrument approprié.",
        "Pour les décisions concernant les enfants, la santé, le handicap ou les enjeux importants, consultez un professionnel qualifié."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "can-iq-change-over-time"],
  "sources": [],
  "faqs": [],
  "summary": "L'anxiété peut consommer l'attention ou la mémoire de travail, mais les effets varient. 18 Juillet 2026."
}
